export default __webpack_public_path__ + "static/media/metamask-icon.3ce7470f.png";